import { render } from "./AdminMessage.vue?vue&type=template&id=733272f2&scoped=true&ts=true"
import script from "./AdminMessage.vue?vue&type=script&lang=ts"
export * from "./AdminMessage.vue?vue&type=script&lang=ts"

import "./AdminMessage.vue?vue&type=style&index=0&id=733272f2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-733272f2"]])

export default __exports__